import { v4 as uuidv4 } from 'uuid'
import { DownloadsRegister } from './DownloadsRegister'
import { LoggedUser } from 'modules/auth/models/LoggedUser'
import { Request } from 'modules/request/models/Request'
import { File } from 'modules/files/models/File'


export interface DownloadsRegisterDTO {
	id:        string
	userID:    string    
	userName:  string    
	userEmail: string    
	clinic:    string    
	date:      Date 
	ipAdress:  string    
	browser:   string    
	doc:       string    
	codeBA:    string 
}

export async function newDownloadsRegisterDTO(
    user: LoggedUser,
    file: File,
    request: Request
): Promise<DownloadsRegisterDTO> {
    const ip = await getPublicIP();

    return {
        id:        uuidv4(),
        userID:    user.id,
        userName:  `${user.firstName} ${user.lastName}`,
        userEmail: user.email,
        clinic:    user.clinicName,
        date:      new Date(),
        ipAdress:  ip,
        browser:   getBrowser(),
        doc:       file.name,
        codeBA:    request.newID,
    };
}

export function fromModel(c: DownloadsRegister): DownloadsRegisterDTO {
  return {
    id: c.id,
    userID: c.userID,    
    userName: c.userName,  
    userEmail: c.userEmail,
    clinic: c.clinic,    
    date: c.date,      
    ipAdress: c.ipAdress,  
    browser: c.browser,   
    doc: c.doc,       
    codeBA: c.codeBA,    
  }
}

export function toModel(c: DownloadsRegisterDTO): DownloadsRegister {
  return new DownloadsRegister(c)
}

function getBrowser(): string {
    const ua = navigator.userAgent;

    if (ua.includes("Edg"))     return "Edge";
    if (ua.includes("OPR"))     return "Opera";
    if (ua.includes("Chrome"))  return "Chrome";
    if (ua.includes("Safari"))  return "Safari";
    if (ua.includes("Firefox")) return "Firefox";

    return ua;
}

async function getPublicIP(): Promise<string> {
    try {
        const res = await fetch("https://api.ipify.org?format=json");
        const data = await res.json();
        return data.ip;
    } catch {
        return "unknown";
    }
}
